define(['jquery', 'jquery.transit', 'modernizr', 'container', 'jump'],
    function ($, transit, modernizr, container,jumpFactory) {

        const singleVideoPlayAction = () => {
            return {
                type: 'SINGLE_VIDEO_PLAY',
                payload: {
                    videoPlaying: true
                }
            }
        };

        const singleVideoStopAction = () => {
            return {
                type: 'SINGLE_VIDEO_STOP',
                payload: {
                    videoPlaying: false
                }
            }
        };

        const singleVideoAddPlayerAction = (player) => {
            return {
                type: 'SINGLE_PLAYER_ADD',
                payload: {
                    videoPlayer: player
                }
            }
        };

        const singleVideoPlayReducer = (play = false, action) => {
            switch(action.type) {
                case 'SINGLE_VIDEO_PLAY':
                    return action.payload.videoPlaying;
                case 'SINGLE_VIDEO_STOP':
                    return action.payload.videoPlaying;
                default:
                    return play;
            }
        };

        const singleVideoPlayerReducer = (player = null, action) => {
            if (action.type === 'SINGLE_PLAYER_ADD') {
                return action.payload.videoPlayer;
            } else {
                return player;
            }
        };

        return (function () {

            const name = 'module-single-video';

            const model = container.getBaseModel(name);
            const view = container.getBaseView(name);
            const jump = jumpFactory.create();
            //const pubSub = container.getPublishSubscribe();
            /* model */

            model.publicVars = {};

            model.privateVars = {

            };

            model.methods = {

            };

            /* view */

            view.publicVars = {};

            view.privateVars = {

            };

            view.startup = function () {

                container.getReduxStore().reducerManager.add('singleVideoPlay', singleVideoPlayReducer);
                container.getReduxStore().reducerManager.add('singleVideoPlayer', singleVideoPlayerReducer);
                container.getReduxStore().dispatch(singleVideoStopAction());
                container.getReduxStore().dispatch(singleVideoAddPlayerAction(null));

                view.methods.setupBitmovin(view.publicVars.cssId.playerVideoId.substr(1), {});
            };

            view.bind = function () {

            };

            view.methods = {
                setupBitmovin: (videoPlayerId, options) => {

                    const conf = {
                        key: view.publicVars.bitmovinKey,
                        analytics: false,
                        playback:{
                            autoplay: options.autoplay || false,
                            muted: false
                        },
                        logs: {
                            level: 'off'
                        },

                    };

                    let source = options.source || {
                        progressive: view.publicVars.introVideoSource
                    };

                    if(view.publicVars.introVideoPoster && !options.source) {
                        source.poster = view.publicVars.introVideoPoster;
                    }

                    view.privateVars.player = new bitmovin.player.Player(document.getElementById(videoPlayerId), conf);

                    container.getReduxStore().dispatch(singleVideoAddPlayerAction(view.privateVars.player));

                    // Setup the player
                    view.privateVars.player.load(source).then(function() {

                    }, function () {

                    });

                    view.privateVars.player.on(bitmovin.player.PlayerEvent.Play, function(e) {
                        container.getReduxStore().dispatch(singleVideoPlayAction());

                        jump.centerTo(view.publicVars.cssId.playerVideoId, () => {

                        });

                        const state = container.getReduxStore().getState();

                        if(state.videoPlayerPlayer) {
                            state.videoPlayerPlayer.pause();
                        }

                        if(state.spotifyIframe) {
                            state.spotifyIframe.src = state.spotifyIframe.src;
                        }
                    });

                    view.privateVars.player.on(bitmovin.player.PlayerEvent.Playing, function(e) {

                    });

                    view.privateVars.player.on(bitmovin.player.PlayerEvent.Paused, function(e) {
                        container.getReduxStore().dispatch(singleVideoStopAction());
                    });


                    view.privateVars.player.on(bitmovin.player.PlayerEvent.PlaybackFinished, function(e) {
                        container.getReduxStore().dispatch(singleVideoStopAction());
                    });
                },
            };

            /* custom events */
            //pubSub.subscribe('view/actionGetLightboxItems', view.methods.actionGetLightboxItems);
            //pubSub.subscribe('view/showThx', view.methods.showThx);


            /* public methods */
            return {
                init: function (options) {
                    model.init(options);
                    view.init(options);
                }
            };


        })();

    });
